export const CRUD_BASE = '/crud/v1';
export const LOGIC_BASE = '/logic/v1';
